import React, { useState, useEffect } from 'react';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { Assignment, Edit } from '@material-ui/icons';
import { wsFindBy } from 'services/WService';
import GridItem from 'components/Grid/GridItem';
import RegularButton from 'components/CustomButtons/Button';
import EditStockModal from './EditStockModal';
import { useModal } from 'hooks/useModal';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Cód. Almacén', accessor: 'WhsCode', width: 130 },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Bloqueado', accessor: 'Locked', width: 115 },
  { Header: 'Stock', accessor: 'stock', width: 120 },
  { Header: 'Stock comprometido', accessor: 'committedStock', width: 200 },
  { Header: 'Stock pedido', accessor: 'StockReceive', width: 150 },
  { Header: 'Stock mínimo', accessor: 'minimunStock', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default function Stock(props) {
  const { dataProduct } = props;

  const [stocks, setStocks] = useState([]);
  const [model, setOpen] = useModal();

  async function listStocks() {
    let response = await wsFindBy('logi/stock', 'logi_product_id', dataProduct.id);
    if (response.success) setStocks(response.data);
  }

  useEffect(() => {
    listStocks();
  }, []);

  return (
    <GridItem xs={12}>
      <EditStockModal model={model} setOpen={setOpen} listStocks={listStocks} />
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 style={{ color: 'black' }}>Listado de Stocks</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={'Stocks_' + dataProduct.ItemName}
            defaultWidth={1200}
            columns={columns}
            data={stocks.map((item, i) => {
              return {
                num: (
                  <>
                    {i + 1}
                    <RegularButton
                      color="warning"
                      justIcon
                      round
                      simple
                      onClick={() => setOpen(item)}
                    >
                      <Edit />
                    </RegularButton>
                  </>
                ),
                WhsCode: item.WhsCode,
                WhsName: item.WhsName,
                Locked: item.Locked === 'Y' ? 'Si' : 'No',
                stock: item.OnHand,
                committedStock: item.IsCommited,
                StockReceive: item.OnOrder,
                minimunStock: item.MinStock,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </GridItem>
  );
}
